/************
Collection Header
***********/

// open drop down
document.querySelectorAll(".collectionDropdownTitle").forEach(function (element) {
    element.addEventListener("click", function (e) {
        e.preventDefault();
        if (this.classList.contains("active")) {
            this.classList.remove("active");
        } else {
            if (document.querySelector(".collectionDropdownTitle.active")) {
                document.querySelector(".collectionDropdownTitle.active").classList.remove("active");
            }

            this.classList.add("active");
        }
    });
});

//close drop down
document.querySelector("body").addEventListener("click", function (e) {
    if (e.target.closest(".collectionDropdown") == null) {
        if (document.querySelector(".collectionDropdownTitle.active")) {
            document.querySelector(".collectionDropdownTitle.active").classList.remove("active");
        }
    }
});